/* @flow */

export const STEP_ENUM = {
  'INIT': 'INIT',
  'QUESTION': 'QUESTION',
  'PASSED': 'PASSED',
  'TRYAGAIN': 'TRYAGAIN',
  'ANSWERFAILED': 'ANSWERFAILED',
};

export const QUESTION_STATUS_MAP = {
  'Success': {
    step: STEP_ENUM.PASSED,
    params: {},
  },
  'TimeOut': {
    step: STEP_ENUM.TRYAGAIN,
    params: { errorType: 'timeout' },
  },
  'Fail': {
    step: STEP_ENUM.TRYAGAIN,
    params: { errorType: 'answerfailed' },
  },
  // 'CurrentContinue': {
  //   step: STEP_ENUM.TRYAGAIN,
  //   params: { errorType: 'answerfailed' },
  // },
  // 'OldContinue': {
  //   step: STEP_ENUM.ANSWERFAILED,
  //   params: { errorType: 'device' },
  // },
  // 'OldDown': {
  //   step: STEP_ENUM.ANSWERFAILED,
  //   params: { errorType: 'olddown' },
  // },
};

export const TEXT_CONFIG = {
  mobile: {
    title: 'exchange-mobile-title',
    option1: 'exchange-mobile-option1',
    option2: 'exchange-mobile-option2',
    btn: 'exchange-google-start2fa',
  },
  google: {
    title: 'exchange-google-title',
    option1: 'exchange-google-option1',
    option2: 'exchange-google-option2',
    btn: 'exchange-google-start2fa',
  },
  enable: {
    title: 'exchange-enable-title',
    option1: 'exchange-enable-option1',
    option2: 'exchange-enable-option2',
    btn: 'exchange-enable-title',
  },
  withdrawface: {
    title: 'exchange-reset2fa-facialVerify',
  },
};

const TYPES = ['google', 'mobile', 'enable', 'withdrawface'];
export const formatType = (type: string = 'google') => {
  type = type.toLowerCase();
  return TYPES.includes(type) ? type : 'google';
};

export default {};
